<template>
  {{month}}/{{day}}/{{year}} {{hour}}:{{minutes}}
</template>

<script>
export default {
  name: 'ClockElement',
  data: function data () {
    return {
      hour: '',
      minutes: '',
      seconds: '',
      day: '',
      month: '',
      year: ''
    }
  },
  mounted () {
    setInterval(this.updateDateTime, 1000)
  },
  methods: {
    updateDateTime: function updateDateTime () {
      var now = new Date()
      this.year = now.getFullYear()
      this.month = this.getZeroPad(now.getMonth() + 1)
      this.day = this.getZeroPad(now.getDate())
      this.hours = now.getHours()
      this.minutes = this.getZeroPad(now.getMinutes())
      this.seconds = this.getZeroPad(now.getSeconds())
      this.hour = this.hours
    },
    getZeroPad: function getZeroPad (n) {
      return (parseInt(n, 10) >= 10 ? '' : '0') + n
    }
  }
}
</script>
